import { Dispatch } from "redux";
import { CALL_API } from "../api.middleware";
import { changePopupDescription } from "./toast";
import { handleError } from "../../utils/cart";

export const newPurchase = (payload: any) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: `/transactions/new-purchase`,
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
    dispatchPopup(response)(dispatch);
    return response;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
  }
};

export const additionalPurchase = (payload: any) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: `/transactions/additional-purchase`,
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
    dispatchPopup(response)(dispatch);
    return response;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
  }
};

export const newSIPwithOrwithoutPayment =
  (payload: any) => async (dispatch: any) => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: `/transactions/new-purchase-sip`,
          method: "POST",
          showLoader: true,
          body: payload,
          isCart: true,
        },
      });
      dispatchPopup(response)(dispatch);
      return response;
    } catch (error) {
      alert(`${error}`);
    }
  };

export const existingFolioSIPwithOrwithoutPayment =
  (payload: any) => async (dispatch: any) => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: `/transactions/additional-purchase-sip`,
          method: "POST",
          showLoader: true,
          body: payload,
          isCart: true,
        },
      });
      dispatchPopup(response)(dispatch);
      return response;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      }
    }
  };

export const sipNewPurchase = (payload: any) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: `/transactions/new-purchase-sip`,
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
    dispatchPopup(response)(dispatch);
    return response;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
  }
};

export const redemptionTransaction =
  (payload: any) => async (dispatch: any) => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          url: `/transactions/redemption`,
          method: "POST",
          showLoader: true,
          body: payload,
          isCart: true,
        },
      });
      dispatchPopup(response)(dispatch);
      return response;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      }
    }
  };

export const swpTransaction = (payload: any) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: `/transactions/swp`,
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
    dispatchPopup(response)(dispatch);
    return response;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
  }
};

export const switchTransaction = (payload: any) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: `/transactions/switch`,
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
    dispatchPopup(response)(dispatch);
    return response;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
  }
};

export const stpTransaction = (payload: any) => async (dispatch: any) => {
  try {
    const response = await dispatch({
      [CALL_API]: {
        url: `/transactions/stp`,
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
    dispatchPopup(response)(dispatch);
    return response;
  } catch (error) {
    handleError(error);
    if (error instanceof Error) throw error;
  }
};

// export const cancelSTP = (payload) => async (dispatch) => {
//   try {
//     return await dispatch({
//       [CALL_API]: {
//         url: `/transactions/stp`,
//         method: "POST",
//         types: [STP_TRANSACTION, STP_TRANSACTION_SUCCESS],
//         showLoader: true,
//         body: payload,
//         isCart: true,
//       },
//     });
//   } catch (error) {
//     alert(`${error}`);
//   }
// }

export const cancelSIP = (payload: any) => async (dispatch: any) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/transactions/sip-cancellation`,
        method: "POST",
        showLoader: true,
        body: payload,
        isCart: true,
      },
    });
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
  }
};

export const dispatchPopup =
  ({
    ihno,
    isKYCInvalid,
    kycMessage,
  }: {
    isKYCInvalid: boolean;
    kycMessage: string;
    ihno: any;
  }) =>
  (dispatch: Dispatch<any>) => {
    if (isKYCInvalid) {
      changePopupDescription({
        main: `Transaction initiated successfully with the reference number ${ihno}`,
        sub: kycMessage,
      })(dispatch);
      return;
    }
    changePopupDescription({
      main: `Transaction initiated successfully with the reference number ${ihno}`,
    })(dispatch);
  };
